export enum SimpahProfitUnitType {
  QUINTAL = 'QUINTAL',
  MEDIDA = 'MEDIDA',
  POUND = 'POUND',
}
